import { useMaestroStore } from '../store/maestroStore';
import { isPlaybackStoppedForReload } from '../utils/webBundleMeta';

function parseCurrentTransportState(rawResp: string): string {
  const match = rawResp.match(/<CurrentTransportState>(.*?)<\/CurrentTransportState>/);
  return match?.[1] || 'UNKNOWN';
}

/** True when a network renderer is actively playing (authoritative over idle local store). */
export async function isRendererPlaybackBlockingWebReload(): Promise<boolean> {
  if (!isPlaybackStoppedForReload()) return true;
  if (!(window as any).__TAURI__) return false;
  const rendererId = useMaestroStore.getState().activeConnectorRenderer?.id;
  if (!rendererId) return false;
  try {
    const { getTransportInfo } = await import('../lib/connector');
    const raw = await getTransportInfo(rendererId);
    const state = parseCurrentTransportState(raw);
    return state === 'PLAYING' || state === 'TRANSITIONING';
  } catch {
    return false;
  }
}
